import { atom } from 'recoil';

const generateSessionId = () => {
  const timestamp = Date.now().toString(36);
  const random = Math.random().toString(36).substring(2, 8);
  return `${timestamp}-${random}`;
};

export const initialBookingSessionState = {
  sessionId: generateSessionId(),
};

const bookingSessionState = atom({
  key: 'bookingSession',
  default: initialBookingSessionState,
});

export default bookingSessionState;
